import { Component, Input } from '@angular/core';
import { Navigator } from 'src/app/components/menu/navigator';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { EventsService } from 'src/app/services/event/event.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';

@Component({
  templateUrl: 'w2g.html',
  styleUrls: ['./w2g.scss'],
})

export class W2GPopover {
  public consent;
  public canSave: boolean = false;
  @Input() callBackFn: any;


  constructor(
    public navigator: Navigator,
    // public viewCtrl: ViewController,
    public userProvider: UserSessionService,
    public authenticationProvider:AuthenticationService,
    private eventsService:EventsService,
    private appLinksService:AppLinksService
    ) {
      // console.log(this.viewCtrl.data);
      console.log('w2g'); 

      // logout service will dismiss all modals itself
      // this.eventsService.subscribe("event:authentication:logout",() => {
      //   this.navigator.dismiss();
      // })
  }

  yes() {

    let customer_consent: any = [];
    customer_consent['propName'] = "W2G_ELECTRONIC_MAIL_CONSENT";
    customer_consent['propValue'] = true;

    console.log("test out of consesnt");
    // TEST UNCOMMENT THIS
    this.authenticationProvider.updateCustomData(customer_consent).subscribe(
      (resp) => {
          console.log("test resp in updateCustomData", resp);
          this.userProvider.refreshCustomer().subscribe(() => {});
      });
      if(!!this.callBackFn){
        this.callBackFn();
        this.navigator.dismiss();
      } else {
        this.navigator.dismiss();
      }
  }

  no() {
    this.consent = "false";
    let customer_consent: any = [];
    customer_consent['propName'] = "W2G_ELECTRONIC_MAIL_CONSENT";
    customer_consent['propValue'] = false;

    this.authenticationProvider.updateCustomData(customer_consent).subscribe(
      (resp) => {
          this.userProvider.refreshCustomer().subscribe(() => {});
      });
      if(!!this.callBackFn){
        this.callBackFn();
        this.navigator.dismiss();
      } else {
        this.navigator.dismiss();
      }
  }

  closePopover() {
      this.no();
  }

  openMatchedExternalLinks(code, title) {
    return this.appLinksService.openMatchedExternalLinksPopover(code, title)
  }

}